// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"812":"83fa9a3b","1844":"83fa9a3b","7347":"83fa9a3b"}[chunkId] + ".chunk.css";
};